._14iyvb70 {
  border: none;
  outline: none;
  background-color: var(--input-background-color) !important;
  font-family: var(--input-font-family);
  font-weight: var(--input-font-weight);
  font-size: var(--input-font-size);
  text-align: var(--text-align, left);
}
._14iyvb70::placeholder {
  color: var(--placeholder-color);
  font-family: var(--input-font-family);
  font-weight: var(--input-font-weight);
  font-size: var(--input-font-size);
  text-align: var(--text-align, left);
}
._14iyvb70:focus {
  font-size: var(--input-font-size) !important;
}
._14iyvb71 {
  display: flex;
  gap: 6px;
  align-items: flex-start;
}
._14iyvb72 {
  display: block;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;
  color: var(--input-label-color);
  font-family: var(--input-font-family);
  text-align: var(--text-align, left);
  padding: 0px;
  cursor: pointer;
  flex: 1;
  min-width: 0;
}
._14iyvb73 {
  all: unset;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border-color: var(--input-border-color);
  border-width: var(--input-border-width);
  border-style: solid;
  border-radius: var(--input-checkbox-radius);
  display: inline-block;
  cursor: pointer;
  position: relative;
  background-color: var(--input-radio-checkbox-background-color) !important;
  margin-top: 4px;
  margin-right: 0;
  margin-bottom: 0;
  margin-left: 0;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  transform: translateZ(0);
  backface-visibility: hidden;
  box-sizing: border-box;
}
._14iyvb73:checked {
  background-color: var(--input-radio-checkbox-accent-color) !important;
  border-color: var(--input-radio-checkbox-accent-color) !important;
}
._14iyvb73:checked::after {
  content: "";
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
  width: 4px;
  height: 8px;
  border-right: 2px solid var(--input-radio-checkbox-background-color);
  border-bottom: 2px solid var(--input-radio-checkbox-background-color);
  pointer-events: none;
}
._14iyvb73:hover:not(:checked) {
  border-color: var(--input-radio-checkbox-accent-color);
}
._14iyvb73:focus, ._14iyvb73:focus-visible, ._14iyvb73:active, ._14iyvb73:-moz-focusring, ._14iyvb73::-moz-focus-inner {
  outline: none !important;
  box-shadow: none !important;
  border: inherit !important;
}
._14iyvb73:checked:focus, ._14iyvb73:checked:active, ._14iyvb73:checked:hover, ._14iyvb73:checked:focus-visible {
  background-color: var(--input-radio-checkbox-accent-color) !important;
  border-color: var(--input-radio-checkbox-accent-color) !important;
}
._14iyvb73:not(:checked) {
  outline: none;
  box-shadow: none;
}
._14iyvb74 {
  align-items: var(--text-align-items, start);
}
._14iyvb75 {
  all: unset;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border-color: var(--input-border-color);
  border-width: var(--input-border-width);
  border-style: solid;
  display: inline-block;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  background-color: var(--input-radio-checkbox-background-color) !important;
  margin-top: 4px;
  margin-right: 0;
  margin-bottom: 0;
  margin-left: 0;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  transform: translateZ(0);
  backface-visibility: hidden;
}
._14iyvb75:checked {
  background-color: var(--input-radio-checkbox-accent-color) !important;
  border-color: var(--input-radio-checkbox-accent-color) !important;
}
._14iyvb75:checked::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--input-radio-checkbox-background-color);
  pointer-events: none;
}
._14iyvb75:hover:not(:checked) {
  border-color: var(--input-radio-checkbox-accent-color);
}
._14iyvb75:focus, ._14iyvb75:focus-visible, ._14iyvb75:active, ._14iyvb75:-moz-focusring, ._14iyvb75::-moz-focus-inner {
  outline: none !important;
  box-shadow: none !important;
  border: inherit !important;
}
._14iyvb75:checked:focus, ._14iyvb75:checked:active, ._14iyvb75:checked:hover, ._14iyvb75:checked:focus-visible {
  background-color: var(--input-radio-checkbox-accent-color) !important;
  border-color: var(--input-radio-checkbox-accent-color) !important;
}
@media only screen and (--mobile) {
  ._14iyvb70 {
    font-size: var(--mobile-input-font-size);
  }
  ._14iyvb70:focus {
    font-size: var(--mobile-input-font-size) !important;
  }
  ._14iyvb70::placeholder {
    font-size: var(--mobile-input-font-size);
  }
}